import {Form, Input, Select} from "antd";
import {ScheduleFormProps} from "../../types";
import {FC, useMemo} from "react";
import {VALIDATION_MESSAGES} from "../../../../../../enums/validationMessages";
import "./style.less"

const availableDaysOptions = [
  {label: "Понеділок", value: "Понеділок"},
  {label: "Вівторок", value: "Вівторок"},
  {label: "Середа", value: "Середа"},
  {label: "Четвер", value: "Четвер"},
  {label: "П’ятниця", value: "П’ятниця"},
  {label: "Субота", value: "Субота"},
  {label: "Неділя", value: "Неділя"}
];

const ScheduleForm: FC<ScheduleFormProps> = (props) => {
  const {staffList, scheduleController} = props

  const staffFieldOptions = useMemo(() => {
    return staffList
      .map((staff) => ({
        label: `${staff.fullName} - ${staff.position}`,
        value: staff.$id,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [staffList]);

  return <Form form={scheduleController.scheduleForm} layout="vertical" className="schedule_form"
               onFinish={scheduleController.submitFormHandler}>
    <Form.Item name="staff" label="Лікар" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
      <Select showSearch allowClear disabled={!!scheduleController.selectedSchedule}
              options={staffFieldOptions}/>
    </Form.Item>
    <Form.Item name="availableDays" label="Дні прийому"
               rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
      <Select mode="multiple" options={availableDaysOptions}/>
    </Form.Item>
    <Form.Item name="availableTime" label="Години прийому"
               rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
      <Input/>
    </Form.Item>
  </Form>
}

export default ScheduleForm